export const config = {
  defaultHeight: 400,
  passwordResetLink: "https://studio.mittwald.de/register/reset/password",
};

export default config;
